// extracted by mini-css-extract-plugin
module.exports =  {"breadcrumb":"jut__Breadcrumb__breadcrumb","breadcrumbLink":"jut__Breadcrumb__breadcrumbLink","currentLink":"jut__Breadcrumb__currentLink","divider":"jut__Breadcrumb__divider"};